import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom'
import './bootstrap.min-tap.css'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import axios from 'axios';

// ── Audit interceptors ──────────────────────────────────────────────────────
// Every outgoing request gets stamped with X-Actor (the logged-in username)
// so the backend audit middleware can record WHO acted, regardless of what
// the request body contains. Applies to both axios and fetch so call sites
// don't need to change.
const _currentActor = () => {
  try {
    const raw = localStorage.getItem('userInfo');
    if (!raw) return '';
    const u = JSON.parse(raw);
    return u?.username || u?.email || u?.name || '';
  } catch (_) { return ''; }
};

// Pull the active branch id from the logged-in userInfo. Backend reads it
// from x-branch-id and scopes inserts/queries to that branch. Defaults to
// null when the user hasn't logged in yet so the request is treated as
// pre-auth (login itself doesn't need the header).
const _currentBranchId = () => {
  try {
    const raw = localStorage.getItem('userInfo');
    if (!raw) return null;
    const u = JSON.parse(raw);
    return u?.branch?.id || null;
  } catch (_) { return null; }
};

axios.interceptors.request.use((config) => {
  const actor = _currentActor();
  if (actor) {
    config.headers = config.headers || {};
    config.headers['X-Actor'] = actor;
  }
  const bId = _currentBranchId();
  if (bId) {
    config.headers = config.headers || {};
    config.headers['X-Branch-Id'] = String(bId);
  }
  return config;
});

if (typeof window !== 'undefined' && typeof window.fetch === 'function' && !window.__auditFetchPatched) {
  const _origFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    try {
      const actor = _currentActor();
      const bId   = _currentBranchId();
      if (actor || bId) {
        const headers = new Headers(init.headers || (input && input.headers) || {});
        if (actor && !headers.has('X-Actor'))     headers.set('X-Actor', actor);
        if (bId   && !headers.has('X-Branch-Id')) headers.set('X-Branch-Id', String(bId));
        init = { ...init, headers };
      }
    } catch (_) { /* fall through to original fetch */ }
    return _origFetch(input, init);
  };
  window.__auditFetchPatched = true;
}
// ────────────────────────────────────────────────────────────────────────────

const theme = createTheme({
  palette: {
    primary: {
     main: '#10b981',
      light: '#10b981',
      dark: '#10b981',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
